import React, {Component} from 'react';
import config from 'react-global-configuration';
import {Link} from "react-router-dom";
import axios from "axios";
import $ from 'jquery';
import 'datatables.net';
import "datatables.net-responsive";
import "../../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../../assets/css/react-confirm-alert/react-confirm-alert.css';
//import {confirmAlert} from 'react-confirm-alert';
import ReactTooltip from 'react-tooltip';
//import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class MappedData extends Component {
    constructor(props){
        super(props);
        this.state = {
            mapped_files : [],
            mappedData: {
                id: '',
                user_id: '',
                file_name: '',
                file_path: '',
                timestamp: '',
                version: '',
                cur_version: '',
                status:'',
                user_type: ''
            },
            mappedModel: false,
            data:[],
            loading:true,
            _notificationSystem: null,
            versions:[],
            tableLists:[],
            newRelationModel: false,
            relationData: [{ tables:"", columnLists:"", columns:"", id:"", relationToTables:"", toTables:"", toColumnLists:"", toColumns:"" }],
            deleteKeys:[]
        }

    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        //this._getVersions();
        this._refreshMapped();
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
    }

    mappedData(id, user_id, file_name, file_path, timestamp, version, cur_version, status, user_type) {
        this.setState({
            mappedData: {
                id,
                user_id,
                file_name,
                file_path,
                timestamp,
                version,
                cur_version,
                status,
                user_type
            },
            mappedModel: !this.state.mappedModel
            //login_type:loginType
        });
        this._RawData(user_id, file_name, timestamp)
        //this.findGroups(userType);
        //this.findAccessKeys(id);
    }

    togglemappedModel() {
        this.setState({
            mappedModel: !this.state.mappedModel
        })
    }

    _refreshMapped() {
        if ($.fn.DataTable.isDataTable('#mappedTable')) {
            $('#mappedTable').DataTable().destroy();
        }
        axios.get(config.get('API_URL')+'/brandemi/get_mapped',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            }).then(response => {
            console.log(response.data);
            this.setState({
                mapped_files: response.data
            });
            $('#mappedTable').DataTable();
            this.setState({
                loading: false
            })

        });
    }

    render() {

        //console.log(this.state.relationData);
        let versions = this.state.versions.map((version,index) => {
            return (
                <option value={version.id} key={index+1}>{version.name}</option>
            )
        });

        let tablesData = this.state.tableLists.map((table,index) => {
            return (
                <option value={table.id} key={index+1}>{table.tableName}</option>
            )
        });

        let mapped_data = this.state.mapped_files.map((mapped,index) => {
            return (
                <tr key={index + 1}>
                    <td>{index + 1}</td>
                    <td>{mapped.user_id}</td>
                    <td>{mapped.file_name}</td>
                    <td>{mapped.user_type}</td>
                    <td>{mapped.record_update_timestamp}</td>
                    <td>
                        <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                        <Link className="viewButton" data-tip="View"  to={"/admin/mapped-view/" + mapped.id}><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
                        <Link className="viewButton" data-tip="Link Data"  to={"/admin/unmapped-view/" + mapped.id}><span className="glyphicon glyphicon-link" aria-hidden="true"></span></Link>
                    </td>
                </tr>
            )
        });

        
        return(
            <div className="card-query-builder">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                <div className="content">
                    <div className='sweet-loading'>
                        <BeatLoader
                            css={override}
                            sizeUnit={"px"}
                            size={20}
                            color={'#123abc'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div className="content table-full-width table-responsive">
                        <table className="table table-striped table-hover" id="mappedTable">
                            <thead>
                            <tr>
                                <th>Sr_No.</th>
                                <th>User_ID</th>
                                <th>File_Name</th>
                                <th>User_Type</th>
                                <th>Timestamp</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            {mapped_data}
                            </tbody>
                        </table>
                    </div>

                    <div className="footer">
                        <div className="stats"><i></i></div>
                    </div>
                </div>

            </div>
        );
    }
}
export default MappedData;